import Advertisement, { Banner, AdvertisementType } from '~kup/models/Advertisement.ts';

type AdvertisementEventData = {
  id: string;
  slug: string;
  bannerType: AdvertisementType;
  categoryCode: string;
  banner: {
    id: string;
    slug: string;
    type: string;
    title: string;
  };
};

export function extractAdvertisementEventData(
  advertisement: Advertisement,
  banner: Banner
): AdvertisementEventData {
  return {
    id: advertisement.id,
    slug: advertisement.slug,
    bannerType: advertisement.bannerType,
    categoryCode: advertisement.categoryCode,
    banner: {
      id: banner.id,
      slug: banner.slug,
      type: banner.type,
      title: banner.title,
    },
  };
}
